import { QuestionListPage } from './QuestionListPage';
export default QuestionListPage;
